/** URLs canônicas das páginas do menu de perfil e áreas administrativas. */
export const APP_PATHS = {
  SUBSCRIPTION: '/subscription',
  SETTINGS: '/settings',
  USERS: '/users',
  ROLES: '/roles',
  CHANNELS: '/tickets/channels',
};

export const getRoleEditPath = (roleId) => `${APP_PATHS.ROLES}/${roleId}/edit`;
export const getRoleNewPath = () => `${APP_PATHS.ROLES}/new`;

/** Chave em `location.state` para abrir a edição de uma conexão específica ao redirecionar para Conexões. */
export const OPEN_CONNECTION_STATE = 'openConnectionId';
/** Chave em `location.state` para pré-selecionar uma aba do modal de edição da conexão. */
export const OPEN_CONNECTION_TAB_STATE = 'openConnectionTab';

export const getConnectionEditPath = (whatsappId, tab) => ({
  pathname: APP_PATHS.CHANNELS,
  state: {
    [OPEN_CONNECTION_STATE]: whatsappId,
    ...(tab ? { [OPEN_CONNECTION_TAB_STATE]: tab } : {}),
  },
});
